import PropTypes from "prop-types";
import React from "react";
import grades from "../../../../../config/shared_portal_grades.json";
import FormField from "./FormField";

const GradeField = ({name, label, required}) => {
  return (
    <FormField label={label} type="select" name={name} options={grades} colWidth={6} required={required} />
  );
};

GradeField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  required: PropTypes.bool
};

GradeField.defaultProps = {
  required: false
};

export default GradeField;
